module.exports = __webpack_public_path__ + "img/popup_gyeonggi_hospital_famdoc.d981f77b.png";